import { Check } from "lucide-react";

export function CheckOption({ label, checked, onChange, disabled, tag, testId }) {
  return (
    <div
      onClick={disabled ? undefined : onChange}
      data-testid={testId}
      className="flex items-center gap-2.5 rounded-xl mb-1.5 transition-all duration-150"
      style={{
        padding: "10px 14px",
        background: checked ? "#E3F0F5" : "transparent",
        border: checked
          ? "1.5px solid rgba(0,98,143,0.27)"
          : "1.5px solid #E2D9CB",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.85 : 1,
      }}
    >
      <div
        className="flex items-center justify-center shrink-0 transition-all duration-150"
        style={{
          width: 20,
          height: 20,
          borderRadius: 6,
          border: checked ? "none" : "2px solid #E2D9CB",
          background: checked ? "#00628F" : "transparent",
        }}
      >
        {checked && <Check size={13} color="white" strokeWidth={3} />}
      </div>
      <span
        className="text-[13px] flex-1"
        style={{
          color: "#2D2A24",
          fontWeight: checked ? 600 : 400,
        }}
      >
        {label}
      </span>
      {tag && (
        <span
          className="text-[9px] font-bold px-2 py-0.5 rounded-lg"
          style={{
            background: "#E2F0E8",
            color: "#157346",
          }}
        >
          {tag}
        </span>
      )}
    </div>
  );
}
